/**
 * App Registry — Option B: product apps use `url` under `/remote/*` (separate Vite SPAs).
 */

export interface AppConfig {
  id: string;
  label: string;
  path: string;
  icon: string;
  url: string;
  enabled: boolean;
  badge?: number;
  description: string;
  requiresSuperAdmin?: boolean;
  sidebarOrder?: number;
  useBetaVersion?: boolean;
  currentVersion?: string;
  betaVersion?: string;
  customConfig?: Record<string, unknown>;
  navigation?: {
    customLabel?: string;
    isVisible?: boolean;
    displayOrder?: number;
  };
}

const apps: AppConfig[] = [];

export default apps;

export const getEnabledApps = (): AppConfig[] => apps.filter((a) => a.enabled);
export const getAppById = (id: string): AppConfig | undefined => apps.find((a) => a.id === id);
